import { fromJS } from 'immutable';
import * as actionTypes from '../actions/userListActionTypes';

const initialState = fromJS({
  userList: null,
});

const userList = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.USER_LIST_REQUEST: {
      const requestData = fromJS(action).remove('type');
      return state.set('userList', requestData);
    }
    case actionTypes.USER_LIST_SUCCESS:
      return state.set('userList', action.res);
    case actionTypes.USER_LIST_FAILURE:
      return state.set('userList', action.error);
    case actionTypes.USER_LIST_DISMISS:
      return state.set('userList', null);
    default:
      return state;
  }
};

export default userList;



// WEBPACK FOOTER //
// ./src/js/reducers/userList.js